module.exports = __webpack_public_path__ + "static/obstacle-55feed5e4ae9864b0d295023d4bc1602.png";